import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import { FC } from 'react';
import Styles from './HouseDistances.module.scss';
import Divider from '@/components/UI/divider/Divider';
type Props = {
  distancesData;
};
const HouseDestances: FC<Props> = ({
  distancesData
}) => {
  return <Box data-sentry-element="Box" data-sentry-component="HouseDestances" data-sentry-source-file="HouseDistances.tsx">
      {!!distancesData.drivingDistances.length && <Box className={Styles['distance-content']}>
          <Typography variant="bodyM_Bold" color="neutral_800" className={Styles['title']} component="p">
            دسترسی با خودرو
          </Typography>
          <Divider />
          {distancesData.drivingDistances?.map((item, index) => <Box className={Styles['distance-card']} key={`DRIVING_${index}`}>
              <Typography variant="bodyM" color="secondary_main">
                {item.distance}
              </Typography>
              <Typography variant="bodyM" color="neutral_800">
                {item.time}
              </Typography>
            </Box>)}
        </Box>}
      {!!distancesData.walkingDistances.length && <Box className={Styles['distance-content']}>
          <Typography variant="bodyM_Bold" color="neutral_800" className={Styles['title']} component="p">
            دسترسی به صورت پیاده{' '}
          </Typography>
          <Divider />
          {distancesData.walkingDistances?.map((item, index) => <Box className={Styles['distance-card']} key={`WALKING_${index}`}>
              <Typography variant="bodyM" color="secondary_main">
                {item.distance}
              </Typography>
              <Typography variant="bodyM" color="neutral_800">
                {item.time}
              </Typography>
            </Box>)}
        </Box>}
    </Box>;
};
export default HouseDestances;